import React, { useEffect, useState } from 'react'
import { Link, useLocation } from "react-router-dom";

import {
    Sidebar,
    Menu,
    MenuItem,
    SubMenu
} from 'react-pro-sidebar';
import { getUsuarioStorage } from '../helpers/getUsuarioStorage';
import { useGetPantallas } from '../hooks/useGetPantallas';
import { UsuarioPassword } from './usuarioPassword';

const menuItemStyles = {

    button: ({ active }) => {

        return {
            borderRadius: '14px',
            margin: '6px 12px',
            height: 48,
            color: '#ecfeff',

            backgroundColor: active
                ? '#14b8a6'
                : 'transparent',

            boxShadow: active
                ? '0 4px 12px rgba(0,0,0,.20)'
                : 'none',

            fontWeight: active ? 700 : 500,

            '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.10)',
                color: '#ffffff',
            },
        };
    },

    icon: {
        color: '#a5f3fc',
        fontSize: '16px',
    },

    label: {
        fontSize: '14px',
        fontWeight: 500,
    },

    subMenuContent: {
        backgroundColor: '#115e59',
        borderRadius: '12px',
        margin: '0 10px',
    },

};

export const SideMenu = ({
    collapsed,
    toggled,
    setToggled
}) => {


    let [usuario] = useState(getUsuarioStorage())
    const pantallas = useGetPantallas();
    const location = useLocation();
    const [openMenu, setOpenMenu] = useState(null);

    const [showPassword, setShowPassword] = useState(false);
    const handleShowPassword = () => setShowPassword(true);

    // const toggleAdmin = () => {
    //     setOpenMenu(openMenu === "admin" ? null : "admin");
    // };

    // const toggleInformes = () => {
    //     setOpenMenu(openMenu === "informes" ? null : "informes");
    // };

    useEffect(() => {

        if (
            location.pathname === "/tiposAtencion" ||
            location.pathname === "/modulos-creacion" ||
            location.pathname === "/ubicaciones" ||
            location.pathname === "/usuarios" ||
            location.pathname === "/videos-admin" ||
            location.pathname === "/mi-empresa"
        ) {
            setOpenMenu("admin");

        }
        else if (
            location.pathname === "/informes" ||
            location.pathname === "/nuevo-dashboard" ||
            location.pathname === "/lista-Pacientes"
        ) {
            setOpenMenu("informes");

        }

    }, [location.pathname]);


    const handleNavigate = () => {

        if (window.innerWidth < 768) {
            setToggled(false);
        }

    };




    return (

        <Sidebar
            collapsed={collapsed}
            toggled={toggled}
            onBackdropClick={() => setToggled(false)}
            breakPoint="md"
            backgroundColor="#0f766e"
            rootStyles={{
                border: 'none',
                minHeight: '100vh',
                color: '#ffffff',
                display: 'flex',
                flexDirection: 'column'
            }}
        >
            <div style={{ display: 'flex', flexDirection: 'column', height: '90vh' }}>
                <div className="sidebar-header" style={{ padding: '16px 20px', display: 'flex', alignItems: 'center', gap: 12 }}>

                    {usuario.imagenLogo || usuario.imagenIcono ? (
                        <img
                            src={
                                (usuario.imagenLogo || usuario.imagenIcono).startsWith('http')
                                    ? (usuario.imagenLogo || usuario.imagenIcono)
                                    : `${process.env.REACT_APP_API_URL || 'http://localhost:8080'}${usuario.imagenLogo || usuario.imagenIcono}`
                            }
                            alt="Logo Empresa"
                            style={{
                                maxHeight: 42,
                                maxWidth: collapsed ? 36 : 120,
                                objectFit: 'contain',
                                borderRadius: 8,
                                background: '#ffffff',
                                padding: 4,
                            }}
                            onError={(e) => {
                                e.target.style.display = 'none';
                            }}
                        />
                    ) : (
                        <div className="logo-circle">
                            {usuario.nombreEntidad ? usuario.nombreEntidad.charAt(0).toUpperCase() : 'T'}
                        </div>
                    )}

                    {
                        !collapsed &&
                        (
                            <div style={{ overflow: 'hidden' }}>
                                <div
                                    style={{
                                        color: 'white',
                                        fontWeight: 800,
                                        fontSize: 15,
                                        lineHeight: '1.2',
                                        whiteSpace: 'nowrap',
                                        textOverflow: 'ellipsis',
                                        overflow: 'hidden'
                                    }}
                                >
                                    {usuario.nombreEntidad || 'TicketsApp'}
                                </div>

                                <small
                                    style={{
                                        color: '#ccfbf1',
                                        fontSize: 12,
                                        display: 'block',
                                        marginTop: 2
                                    }}
                                >
                                    {usuario.modulo}
                                </small>
                            </div>
                        )
                    }

                </div>

                <div style={{ flex: 1 }}>
                    <Menu menuItemStyles={menuItemStyles}>

                        {
                            pantallas.includes("escritorios") && usuario.uidModulo !== 'none'
                            && (
                                <MenuItem
                                    active={location.pathname === "/modulo"}
                                    icon={<i className="fa-solid fa-desktop"></i>}
                                    component={<Link to="/modulo" />}
                                    onClick={handleNavigate}
                                >
                                    Módulo
                                </MenuItem>

                            )
                        }

                        {
                            pantallas.includes("consultorios") && usuario.uidModulo !== 'none'
                            && (
                                <MenuItem
                                    active={location.pathname === "/consultorio"}
                                    icon={<i className="fa-solid fa-user-doctor"></i>}
                                    component={<Link to="/consultorio" />}
                                    onClick={handleNavigate}
                                >
                                    Consultorio
                                </MenuItem>

                            )
                        }

                        {
                            (pantallas.includes("tiposatencion") ||
                                pantallas.includes("creacionescritorios") ||
                                pantallas.includes("creacionubicaciones") ||
                                pantallas.includes("usuarios") ||
                                pantallas.includes("videoslistas"))
                            && (
                                <SubMenu
                                    open={openMenu === "admin"}
                                    onOpenChange={(open) => setOpenMenu(open ? "admin" : null)}
                                    label="Administración"
                                    icon={<i className="fa-solid fa-gear"></i>}
                                >
                                    {pantallas.includes("tiposatencion")
                                        && (
                                            <>
                                                <MenuItem
                                                    active={location.pathname === "/tiposAtencion"}
                                                    component={<Link to="/tiposAtencion" />}
                                                    onClick={handleNavigate}
                                                >
                                                    Tipos Atención
                                                </MenuItem>
                                                <MenuItem
                                                    active={location.pathname === "/modulos-tiposAtencion"}
                                                    component={<Link to="/modulos-tiposAtencion" />}
                                                    onClick={handleNavigate}
                                                >
                                                    Módulos - Tipos Atención
                                                </MenuItem>
                                            </>
                                        )
                                    }
                                    {pantallas.includes("creacionubicaciones")
                                        && (

                                            <MenuItem
                                                active={location.pathname === "/ubicaciones"}
                                                component={<Link to="/ubicaciones" />}
                                                onClick={handleNavigate}
                                            >
                                                Ubicaciones/Sedes
                                            </MenuItem>
                                        )
                                    }
                                    {pantallas.includes("creacionescritorios")
                                        && (

                                            <MenuItem
                                                active={location.pathname === "/modulos-creacion"}
                                                component={<Link to="/modulos-creacion" />}
                                                onClick={handleNavigate}
                                            >
                                                Módulos
                                            </MenuItem>
                                        )
                                    }

                                    {pantallas.includes("usuarios")
                                        && (
                                            <MenuItem
                                                active={location.pathname === "/usuarios"}
                                                component={<Link to="/usuarios" />}
                                                onClick={handleNavigate}
                                            >
                                                Usuarios
                                            </MenuItem>

                                        )
                                    }
                                    {pantallas.includes("videoslistas")
                                        && (

                                            <MenuItem
                                                active={location.pathname === "/videos-admin"}
                                                component={< Link to="/videos-admin" />}
                                                onClick={handleNavigate}
                                            >
                                                Lista de Videos
                                            </MenuItem>
                                        )
                                    }

                                    {(pantallas.includes("tiposatencion") || pantallas.includes("miempresa") || pantallas.includes("usuarios"))
                                        && (
                                            <MenuItem
                                                active={location.pathname === "/mi-empresa"}
                                                component={<Link to="/mi-empresa" />}
                                                onClick={handleNavigate}
                                            >
                                                🏢 Mi Empresa
                                            </MenuItem>
                                        )
                                    }


                                </SubMenu>
                            )
                        }


                        {
                            (pantallas.includes("informes") ||
                                pantallas.includes("listapacientes"))
                            && (
                                <SubMenu
                                    open={openMenu === "informes"}
                                    onOpenChange={(open) => setOpenMenu(open ? "informes" : null)}
                                    label="Informes"
                                    icon={<i className="fa-solid fa-chart-column"></i>}
                                >
                                    {pantallas.includes("informes")
                                        && (
                                            <MenuItem
                                                active={location.pathname === "/informes"}
                                                component={<Link to="/informes" />}
                                                onClick={handleNavigate}
                                            >
                                                Dashboard
                                            </MenuItem>

                                        )
                                    }

                                    {pantallas.includes("informes")
                                        && (
                                            <MenuItem
                                                active={location.pathname === "/nuevo-dashboard"}
                                                component={<Link to="/nuevo-dashboard" />}
                                                onClick={handleNavigate}
                                            >
                                                Dashboard Consultorios
                                            </MenuItem>

                                        )
                                    }


                                    {pantallas.includes("listapacientes")
                                        && (
                                            <MenuItem
                                                active={location.pathname === "/lista-Pacientes"}
                                                component={<Link to="/lista-Pacientes" />}
                                                onClick={handleNavigate}
                                            >
                                                Lista Pacientes
                                            </MenuItem>

                                        )
                                    }

                                </SubMenu>

                            )
                        }


                    </Menu>

                </div>

            </div>



            {/* Footer */}
            {
                !collapsed &&
                (
                    <div
                        style={{
                            padding: 16,
                            borderTop: '1px solid rgba(255,255,255,.15)',
                            marginTop: 'auto',

                        }}
                        onClick={handleShowPassword}
                    >
                        <div
                            style={{
                                fontWeight: 600,
                                color: '#fff'
                            }}
                        >
                            {usuario.agente}
                        </div>

                        {/* <small
                            style={{
                                color: '#ccfbf1'
                            }}
                        >
                            {}
                        </small> */}
                    </div>

                )
            }

            <UsuarioPassword
                show={showPassword}
                onClose={() => setShowPassword(false)}
            />


        </Sidebar>

    )
}